import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="menu-label">  
  <div class="menu-label-wrapper">
    <slot></slot>
  </div>  
</div>
`
const TemplateMenuLabel = t

class MenuLabel extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(TemplateMenuLabel.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('MenuLabel connectedCallback')
  }

  static get observedAttributes() {
    return ['data']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'data') {
      console.log('MenuLabel attributeChangedCallback', newValue)
    }
  }
}

if (!customElements.get('ts-navheader-utility-menu-label')) {
  customElements.define('ts-navheader-utility-menu-label', MenuLabel)
}
export { MenuLabel }
